import React from 'react';
import styles from './ActionButtonGroup.modules.scss';


const ActionButtonGroup = ({ children }) => (
  <div className={styles.actionButtonGroup}>{children}</div>
);

export default ActionButtonGroup;
